var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right",attrs:{"id":"copyright"}},[_c('p',[_c('span',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$auth.getAppName())+" "+_vm._s(_vm.$t('All Rights Reserved')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }